export const MODAL_TYPES = {
  VERIFY: 'VERIFY',
  SUCCESS: 'SUCCESS',
  EMPLOYMENT_DETAILS_NOT_FOUND: 'EMPLOYMENT_DETAILS_NOT_FOUND',
};
